<template>
  <v-main>
    <SignupHeader />

    <v-container class="mt-5">
      <v-container :max-width="700">
        <v-layout class="mb-4 mt-4">
          <h2 class="display-1 text-grey-darken-2 text-h4">
            {{ $t('ResetPassword.Title') }}
          </h2>
        </v-layout>
      </v-container>

      <!-- 期限切れの場合 -->
      <template v-if="isKeyOk === false">
        <v-container :max-width="700">
          <v-alert
            variant="outlined"
            type="error"
            :value="true"
          >
            {{ $t('ResetPassword.ExpiredMessage') }}
          </v-alert>
          <v-row
            class="mt-3"
            :max-width="700"
          >
            <v-spacer />
            <v-btn
              variant="flat"
              color="secondary"
              @click="$router.push({name: 'Login'})"
            >
              {{ $t('Back') }}
            </v-btn>
          </v-row>
        </v-container>
      </template>

      <!-- 期限内の場合 -->
      <template v-if="isKeyOk===true && submitted===false">
        <v-container :max-width="700">
          <PasswordInput
            v-model="formData.password"
            field-key="password"
            :label="$t('ResetPassword.NewPassword')"
            required
          />
          <v-row class="mt-3">
            <v-spacer />
            <ActionButton
              submit
              @click="submit()"
            />
          </v-row>
        </v-container>
      </template>

      <!-- 送信後メッセージ -->
      <template v-if="submitted===true">
        <v-container :max-width="700">
          <v-alert
            variant="outlined"
            type="info"
            :value="true"
          >
            {{ $t('ResetPassword.SubmittedMessage') }}
          </v-alert>
          <v-row class="mt-3">
            <v-spacer />
            <v-btn
              color="secondary"
              @click="$router.push({name: 'Login'})"
            >
              {{ $t('Back') }}
            </v-btn>
          </v-row>
        </v-container>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex'
import http from '@/library/no_session_http'
import ActionButton from '@/components/parts/button/ActionButton'
import SignupHeader from '@/components/content/SignupHeader'
import PasswordInput from '@/components/parts/inputs/PasswordInput'

export default {
  components: {
    PasswordInput,
    SignupHeader,
    ActionButton
  },
  props: {},
  data: () => ({
    formData: {
      password: '',
      key: null
    },
    isKeyOk: null,
    submitted: false
  }),
  computed: {
    ...mapGetters(['errorRes'])
  },
  created () {
    this.$store.dispatch('clearErrorRes')
    if (!this.$route.query.key) {
      this.$router.push({ name: 'Login' })
    } else {
      this.checkKey()
    }
  },
  methods: {
    checkKey () {
      http.get('reset-password/', { params: { key: this.$route.query.key } }).then(
        (res) => {
          this.isKeyOk = true
        },
        (error) => {
          console.error(error)
          this.isKeyOk = false
        }
      )
    },
    submit () {
      this.formData.key = this.$route.query.key
      http.put('reset-password/', this.formData).then(
        (res) => {
          this.submitted = true
        }
      )
    },
    redirectLoginPage () {
      location.href = '/login'
    }
  }
}
</script>

<style scoped>
</style>
